<template>
  <div class="text-center">
    <div class="site-header row">
      <div class="col-4"></div>
      <div class="col-4">
        <img src="../../assets/tassyl9-grey.png" class="top-logo mt-4">
        <div class="tagline text-center">
          <p>Connecting you to your future.</p>
        </div>
      </div>
      <div class="col-4"></div>
    </div>
    <div v-if="expired" >
      <h1 class="reset-header">Reset Password to Reactivate Account</h1>
    </div>
    <div v-else >
      <h1 class="reset-header">Reset Password</h1>
    </div>
    <div class="forgotPass">
      <form @submit="updatePass">
        <div v-if="!submitted || message">
          <div class="row justify-content-center">
            <div class="col-sm-8">
              <label><h3>New Password</h3></label>
              <br/>
              <div class="row">
                <i class="fa fa-lock col-2 icon fa-2x"></i> 
                <input type="password" class="form-control col-10" v-model="newPass" minlength="6"
                title="You must include a character from at least 3 of these categories: upper case, lower case, numbers, and special characters."
                pattern="^(?:(?!.*[<>])(?:(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[0-9])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[a-z])(?=.*[A-Z])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[0-9])(?=.*[A-Z]))).*$" required/>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-sm-8">
              <label><h3>Confirm New Password</h3></label>
              <br/>
              <div class="row">
                <i class="fa fa-lock col-2 icon fa-2x"></i> 
                <input type="password" class="form-control col-10" v-model="confirmPass" minlength="6"
                title="You must include a character from at least 3 of these categories: upper case, lower case, numbers, and special characters."
                pattern="^(?:(?!.*[<>])(?:(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[0-9])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[a-z])(?=.*[A-Z])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[0-9])(?=.*[A-Z]))).*$" required/>
              </div>
            </div>
          </div>
          <p v-if="invalid" class="text-danger small mb-3">Password and Password Confirmation must match.</p>
          <p v-if="message" class="text-danger small mb-3"> {{message}} </p> 
        </div>
        <div v-else>
          <h3 class="message"> Your password has been successfully updated. </h3>
        </div>
        <br/>
        <div v-if="!(!message && submitted)" class="row justify-content-center ">
            <button type="submit" class="btn btn-primary update col-7">Update Password</button>
        </div>
      </form>
      <br/>
      <div v-if="!(expired && !submitted)">
        <router-link to="/login"><button class="btn btn-primary return">Return to Log In</button></router-link>
      </div>
      <br/>
    </div>
  </div>
</template>

<script>
import axios from '../../auth.js'
export default {
  props: {
    nextPath: String
  },
  data(){
    return {
      newPass: '',
      confirmPass: '',
      message: null,
      invalid: false,
      submitted: false,
      expired: false
    }
  },
  mounted(){
    // get request to set token before we post
    if ( 1 < Object.keys(this.$route.query).length ) {
      this.expired = true
    }
    axios.get(
    )
  },
  methods:{
    updatePass(event) {
      event.preventDefault()
      if (this.newPass != this.confirmPass) {
        this.invalid = true
      } else {
      axios.put(
        `${process.env.VUE_APP_ENDPOINT}/users/password/`,
          { password: this.newPass, password_confirmation: this.confirmPass, reset_password_token: this.$route.query.reset_password_token }
        )
        .then( () =>{
          this.submitted = true
          this.message = null
          this.$route.push
        })
        .catch(e => {
          this.submitted = true
          this.message = e.response.data.message 
        })
      }
    }
  }
}
</script>

<style scoped>

label {
  margin-bottom: 0px;
  margin-top: 1em;
}

.icon {
  color: #dcdcdc;
} 

.reset-header {
  margin-top: 2em;
  margin-bottom: 2em;
}

.forgotPass {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3em;
  margin-bottom: 3em;
  background-color: white;
  padding-bottom: 2em;
}

.email {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.message {
  padding-top: 2em;
  padding-bottom: 2em;
}

</style>
